import { connect } from "react-redux";

import RequirementsActions from "datamodel/Requirements/actions";
import { getUserId } from "datamodel/User/selectors";

import ListRoomApartment from "./list-room-apartment";

export default connect(
  (state) => ({
    isLoggedIn: !!getUserId(state),
  }),
  (dispatch) => ({
    onRegister: () => dispatch(RequirementsActions.setRegister(true)),
  }),
)(ListRoomApartment);
